@if (isVisible) {
  <div class="confirmation-overlay" (click)="onBackdropClick()">
    <div class="confirmation-dialog" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>{{ title }}</h3>
        <button class="btn-close" (click)="cancel()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="dialog-body">
        <p>{{ message }}</p>
      </div>

      <div class="dialog-footer">
        <button class="btn btn-cancel" (click)="cancel()">
          {{ cancelText }}
        </button>
        <button class="btn btn-confirm" (click)="confirm()">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
}
